type URLS = {
    apiV1: APIV1
}

type APIV1 = {
    misc: MISC,
    editor: EDITOR
    upload: UPLOAD
    gcode: GCODE
    gerberfiles: GERBER
}

type MISC = {
    version(): UrlObject
}
type EDITOR = {
    generate(fileName: string): UrlObject
    getLastCommandOrder(fileName: string): UrlObject
    putCommand(fileName: string): UrlObject
}
type UPLOAD = {
    upload(): UrlObject
}
type GCODE = {
    generate(fileName: string, parameters: string): UrlObject
}
type GERBER = {
    list(): UrlObject
}

export type UrlObject = {
    url: string,
    method: string
}

export const urls: URLS = {
    apiV1: {
        misc: {
            version(): UrlObject {
                return {method: "GET", url: "/api/v1/misc/version"}
            }
        },
        editor: {
            generate(fileName: string): UrlObject {
                return {method: "GET", url: `/api/v1/gerberfile/${fileName}/editor`}
            },
            getLastCommandOrder(fileName: string): UrlObject {
                return {method: "GET", url: `/api/v1/gerberfile/${fileName}/editor/command/orders/last`}
            },
            putCommand(fileName: string): UrlObject {
                return {method: "POST", url: `/api/v1/gerberfile/${fileName}/editor/command`}
            }
        },
        upload: {
            upload(): UrlObject {
                return {method: "POST", url: "/api/v1/gerberfile/upload"}
            }
        },
        gcode: {
            generate(fileName: string, parameters: string): UrlObject {
                return {method: "GET", url: `/api/v1/gerberfile/${fileName}/gcode?parameters=${parameters}`}
            }
        },
        gerberfiles: {
            list(): UrlObject {
                return {method: "GET", url: "/api/v1/gerberfile/list"}
            }
        }
    }
}

export const commands = {
    startLine: {
        typeCode: "START_LINE"
    },
    lineTo: {
        typeCode: "LINE_TO"
    },
    finishLine: {
        typeCode: "FINISH_LINE"
    },
    addHole: {
        typeCode: "ADD_HOLE"
    },
    cancel: {
        typeCode: "CANCEL"
    },
    unCancel: {
        typeCode: "UN_CANCEL"
    },
    setZero: {
        typeCode: "SET_ZERO"
    }
}